// extracted by mini-css-extract-plugin
export var infoItem = "_qv-2";
export var title = "_qv-0";
export var value = "_qv-1";